import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useModulePermission } from '../hooks/usePermission';
import { Modules } from '../constants/permissions';

interface SidebarProps {
  collapsed: boolean;
  onToggle: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ collapsed, onToggle }) => {
  const location = useLocation();
  const auditLogPerm = useModulePermission(Modules.AUDIT_LOG);

  const isActive = (path: string) => {
    if (path === '/user') {
      return location.pathname.startsWith('/user');
    }
    if (path === '/mekak') {
      return location.pathname.startsWith('/mekak');
    }
if (path === '/erp') {
      return location.pathname === '/erp';
    }
    if (path === '/erp/approvals') {
      return location.pathname === '/erp/approvals';
    }
    if (path === '/erp/batch-approval') {
      return location.pathname === '/erp/batch-approval';
    }
if (path === '/cost-calculator') {
      return location.pathname === '/cost-calculator';
    }
if (path === '/module-flow') {
      return location.pathname === '/module-flow';
    }
if (path === '/erp/global-view') {
      return location.pathname === '/erp/global-view';
    }
if (path === '/dev-dashboard') {
      return location.pathname === '/dev-dashboard';
    }
    if (path === '/audit-log') {
      return location.pathname === '/audit-log';
    }
    return location.pathname === path;
  };

  return (
    <div
      className={`fixed left-0 top-0 h-screen bg-white shadow-lg transition-all duration-300 z-20 ${
        collapsed ? 'w-16' : 'w-64'
      }`}
    >
      {/* 收合按鈕 */}
      <button
        onClick={onToggle}
        className="absolute -right-3 top-20 w-6 h-6 bg-white border border-gray-300 rounded-full shadow flex items-center justify-center text-gray-500 hover:bg-gray-100 z-30"
      >
        {collapsed ? '›' : '‹'}
      </button>

      <div className={collapsed ? 'p-2' : 'p-6'}>
        {!collapsed && (
          <h2 className="text-2xl font-bold text-gray-800 mb-6">渤楊系統選單</h2>
        )}
        <nav className={`space-y-2 ${collapsed ? 'mt-16' : ''}`}>
          <Link
            to="/erp"
            title="ERP"
            className={`block py-2 rounded-lg transition-colors ${
              isActive('/erp')
                ? 'bg-blue-500 text-white'
                : 'text-gray-700 hover:bg-gray-100'
            } ${collapsed ? 'text-center px-1' : 'px-4'}`}
          >
            {collapsed ? '🏢' : 'ERP'}
          </Link>
          <Link
            to="/erp/approvals"
            title="待審核"
            className={`block py-2 rounded-lg transition-colors ${
              isActive('/erp/approvals')
                ? 'bg-blue-500 text-white'
                : 'text-gray-700 hover:bg-gray-100'
            } ${collapsed ? 'text-center px-1' : 'px-4'}`}
          >
            {collapsed ? 'V' : '待審核'}
          </Link>
          <Link
            to="/erp/batch-approval"
            title="批次審核"
            className={`block py-2 rounded-lg transition-colors ${
              isActive('/erp/batch-approval')
                ? 'bg-blue-500 text-white'
                : 'text-gray-700 hover:bg-gray-100'
            } ${collapsed ? 'text-center px-1' : 'px-4'}`}
          >
            {collapsed ? 'B' : '批次審核'}
          </Link>
          <Link
            to="/mekak"
            title="知識管理"
            className={`block py-2 rounded-lg transition-colors ${
              isActive('/mekak')
                ? 'bg-blue-500 text-white'
                : 'text-gray-700 hover:bg-gray-100'
            } ${collapsed ? 'text-center px-1' : 'px-4'}`}
          >
            {collapsed ? '🧠' : '知識管理'}
          </Link>
<Link
            to="/inventory"
            title="RFID 盤點"
            className={`block py-2 rounded-lg transition-colors ${
              isActive('/inventory')
                ? 'bg-blue-500 text-white'
                : 'text-gray-700 hover:bg-gray-100'
            } ${collapsed ? 'text-center px-1' : 'px-4'}`}
          >
            {collapsed ? '📦' : 'RFID 盤點'}
          </Link>
          <Link
            to="/cost-calculator"
            title="成本計算機"
            className={`block py-2 rounded-lg transition-colors ${
              isActive('/cost-calculator')
                ? 'bg-blue-500 text-white'
                : 'text-gray-700 hover:bg-gray-100'
            } ${collapsed ? 'text-center px-1' : 'px-4'}`}
          >
            {collapsed ? '$' : '成本計算機'}
          </Link>
          <Link
            to="/user"
            title="使用者管理"
            className={`block py-2 rounded-lg transition-colors ${
              isActive('/user')
                ? 'bg-blue-500 text-white'
                : 'text-gray-700 hover:bg-gray-100'
            } ${collapsed ? 'text-center px-1' : 'px-4'}`}
          >
            {collapsed ? '👤' : '使用者管理'}
          </Link>
<Link
            to="/erp/global-view"
            title="全局視角"
            className={`block py-2 rounded-lg transition-colors ${
              isActive('/erp/global-view')
                ? 'bg-blue-500 text-white'
                : 'text-gray-700 hover:bg-gray-100'
            } ${collapsed ? 'text-center px-1' : 'px-4'}`}
          >
            {collapsed ? 'G' : '全局視角'}
          </Link>
<Link
            to="/module-flow"
            title="模組關聯圖"
            className={`block py-2 rounded-lg transition-colors ${
              isActive('/module-flow')
                ? 'bg-blue-500 text-white'
                : 'text-gray-700 hover:bg-gray-100'
            } ${collapsed ? 'text-center px-1' : 'px-4'}`}
          >
            {collapsed ? '🔗' : '模組關聯圖'}
          </Link>
          <Link
            to="/dev-dashboard"
            title="開發進度"
            className={`block py-2 rounded-lg transition-colors ${
              isActive('/dev-dashboard')
                ? 'bg-blue-500 text-white'
                : 'text-gray-700 hover:bg-gray-100'
            } ${collapsed ? 'text-center px-1' : 'px-4'}`}
          >
            {collapsed ? 'D' : '開發進度'}
          </Link>
          {auditLogPerm.canView && (
            <Link
              to="/audit-log"
              title="稽核記錄查詢"
              className={`block py-2 rounded-lg transition-colors ${
                isActive('/audit-log')
                  ? 'bg-blue-500 text-white'
                  : 'text-gray-700 hover:bg-gray-100'
              } ${collapsed ? 'text-center px-1' : 'px-4'}`}
            >
              {collapsed ? 'A' : '稽核記錄查詢'}
            </Link>
          )}
        </nav>
      </div>
    </div>
  );
};

export default Sidebar;
